import { Link, useLocation } from 'react-router-dom'
import { type Icon } from '@tabler/icons-react'

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'

export function NavMain({
  items,
  deadlineCounts,
}: {
  items: {
    title: string
    url: string
    activeUrl?: string
    icon?: Icon
  }[]
  deadlineCounts: { overdue: number; upcoming7d: number }
}) {
  const location = useLocation()
  const isActivePath = (basePath: string) =>
    location.pathname === basePath || location.pathname.startsWith(`${basePath}/`)

  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            const active = isActivePath(item.activeUrl ?? item.url)
            const isDeadlines = item.url === '/deadlines'
            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  tooltip={item.title}
                  isActive={active}
                >
                  <Link to={item.url}>
                    {item.icon && <item.icon />}
                    <span className={active ? 'text-base font-semibold' : ''}>{item.title}</span>
                    {isDeadlines && (deadlineCounts.overdue > 0 || deadlineCounts.upcoming7d > 0) && (
                      <span className="ml-auto flex items-center gap-1">
                        {deadlineCounts.overdue > 0 && (
                          <span className="text-xs bg-red-100 text-red-800 rounded-full px-1.5 py-0.5 font-medium leading-none">
                            {deadlineCounts.overdue}
                          </span>
                        )}
                        {deadlineCounts.upcoming7d > 0 && (
                          <span className="text-xs bg-yellow-100 text-yellow-800 rounded-full px-1.5 py-0.5 font-medium leading-none">
                            {deadlineCounts.upcoming7d}
                          </span>
                        )}
                      </span>
                    )}
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
